import { PlusIcon } from "lucide-react";

import { Link } from "@/components/Link";
import { Text } from "@/components/ui/text";
import type { Workflow } from "../../types";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function WorkflowsTable({
  workflows,
}: {
  workflows: Workflow[] | undefined;
}) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "workflows",
    workflows,
    [
      {
        field: "name",
        headerName: "Rule",
        cellRenderer: (params) => (
          <Link to="/admin/workflows/$id/edit" params={{ id: params.id }}>
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          name: params.data.name,
          id: params.data.id,
        }),
      },
      {
        field: "description",
        headerName: "Description",
      },
      {
        field: "trigger",
        headerName: "Event",
        cellRenderer: (params) => <Text size="xs">{params.data.trigger}</Text>,
      },
      {
        headerName: "Actions",
        cellRenderer: (params) => (
          <Text size="xs" className="flex h-full items-center">
            {params.data.steps.map((s) => s.action).join(", ")}
          </Text>
        ),
      },
      {
        field: "enabled",
        headerName: "Enabled",
      },
    ],
    { sideBar: undefined },
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link to="/admin/workflows/new" asButton>
          <PlusIcon data-slot="icon" />
          Add rule
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
